import { render, staticRenderFns } from "./EsportBracketLive.vue?vue&type=template&id=6ad3fed4&scoped=true"
import script from "./EsportBracketLive.vue?vue&type=script&setup=true&lang=js"
export * from "./EsportBracketLive.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EsportBracketLive.vue?vue&type=style&index=0&id=6ad3fed4&prod&scoped=true&lang=css"
import style1 from "./EsportBracketLive.vue?vue&type=style&index=1&id=6ad3fed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad3fed4",
  null
  
)

export default component.exports